import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { DateUtils } from 'ng-jhipster';
import { Seller } from '../../entities/seller/seller.model';
@Injectable()
export class SellerDashboardService {

    private resourceUrl = 'api/dashboard/seller';

    constructor(private http: Http, private dateUtils: DateUtils) {
    }


    load(): Observable<Seller> {
        return this.http.get( `${this.resourceUrl}` ).map( (res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.createDate = this.dateUtils
                .convertDateTimeFromServer( jsonResponse.createDate );
            jsonResponse.lastModifiedDate = this.dateUtils
                .convertDateTimeFromServer( jsonResponse.lastModifiedDate );
            return jsonResponse;
        } );
    }


    loadModels(): Observable<Response> {

        return this.http.get( `${this.resourceUrl}/models` );
    }

    touch(): Observable<Response> {

        return this.http.put( `${this.resourceUrl}/touch` ,null);
    }

    loadDevices(): Observable<Response> {

        return this.http.get( `${this.resourceUrl}/devices` );
    }

    loadFiles(): Observable<Response> {

        return this.http.get( `${this.resourceUrl}/files` );
    }

    removeFile(id: number): Observable<Response> {
        return this.http.delete( `${this.resourceUrl}/file/${id}` );
    }

    removeImage(id: number, type: string): Observable<Response> {
        return this.http.delete( `${this.resourceUrl}/image/${id}/${type}` );
    }

    getModelImage(id: number): Observable<Response> {
        return this.http.get( `${this.resourceUrl}/model/${id}` );
    }


    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[ i ].createDate = this.dateUtils
                .convertDateTimeFromServer( jsonResponse[ i ].createDate );
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set( 'page', req.page );
            params.set( 'size', req.size );
            if (req.sort) {
                params.paramsMap.set( 'sort', req.sort );
            }
            params.set( 'query', req.query );

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/seller-dashboard/seller-dashboard.service.ts